define('home/viewmodels/ChannelsViewModel',[
    'backbone',

    'core/UniqueModel',

    'home/collections/ChannelCollection',
    'home/models/FollowRecommendationFeed',
    'home/models/Session',
], function (
    Backbone,

    UniqueModel,

    ChannelCollection,
    FollowRecommendationFeed,
    Session
) {
    'use strict';

    var ChannelsViewModel = Backbone.Model.extend({
        initialize: function () {
            var recommendationAttrs = {
                fetchOptions: {
                    limit: 5,
                },
            };
            this.interestingUsers = FollowRecommendationFeed.createUserFollowRecommendationFeed(recommendationAttrs);
            this.promotedChannels = new ChannelCollection([], { listName: 'promoted' });
            this.sessionUserProfile = Session.get().userProfile;
        },

        ensureFetched: function () {
            this.interestingUsers.ensureFetched();
            this.promotedChannels.ensureFetched();
            this.sessionUserProfile.ensureFetchedAllChannels();
        },
    });

    UniqueModel.addType('ChannelsViewModel', ChannelsViewModel);

    return ChannelsViewModel;
});


